import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useContext,
} from "react";
import { useParams, useHistory } from "react-router";
import {
  Grid,
  Button,
  TextField,
  Typography,
  FormControlLabel,
  Switch,
  Box,
} from "@mui/material";

import CreatableSelect from "react-select/creatable";
import Select from "react-select";

import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import Loader from "../../components/Loader";

import Swal from "sweetalert2";
import Toast from "../../utils/Toast";

import useEditProperty from "../../mutation/property/editProperty";
import useCreateAudit from "../../mutation/audit/createAudit";
import useProperty from "../../queries/property/getProperty";

import useCity from "../../queries/city/getCities";

import RMSProperties from "../../components/property/RMSProperties";

/* import useRMSProperty from "../../queries/property/getPropertiesRMS"; */

import handlePropertyDetails from "../../utils/handlePropertyDetails";

import { AuthContext } from "../../utils/userProvider";

import {
  FormPageShell,
  FormPageCard,
  FormPageHeader,
  FormActions,
} from "../../components/ListPage";

const errorTextSx = {
  mx: 1.75,
  mt: 0.375,
  fontSize: "0.75rem",
  fontWeight: 400,
  color: "secondary.main",
};

const imageLabelSx = {
  fontSize: 16,
  fontWeight: "bold",
};



const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  property_code: yup.string().required("Code is required"),
  stripeSecretKey: yup.string().required("Secret Key is required"),
  stripePublishableKey: yup.string().required("Publishable Key is required"),
  stripeSignature: yup.string().required("Signature is required"),
  city: yup.object().required("A City must be selected."),
  clientPassword: yup.string().required("Client Password is required"),
  clientId: yup.string().required("Client ID is required"),
  deposit_week: yup
    .number()
    .typeError("Deposit must be a number")
    .required("Deposit is required")
    .integer("Number has to have no decimal"),
  security_deposit_week: yup
    .number()
    .transform((val, orig) => (orig == "" ? undefined : val))
    .typeError("Security Deposit must be a number")
    .integer("Number has to have no decimal")
    .nullable(true)
    .optional(),
});

const EditProperty = (props) => {
  const history = useHistory();
  let { id } = useParams();

  const [propertyResponse, resetProperty] = useProperty(id);
  const [auditResponse, setAuditData] = useCreateAudit();

  const [currentData, setCurrentData] = useState();
  const [snapshotCurrent, setSnapshotCurrent] = useState({});

  const [rmsTable, setRmsTable] = useState([]);
  const [suiteIdsText, setSuiteIdsText] = useState("");

  const { authState, setAuthState } = useContext(AuthContext);

  //const [rmsPropertyResponse, resetRMS] = useRMSProperty();

  const [cityOptions, setCityOptions] = useState([]);
  const [cityResponse, resetCity] = useCity();
  const [selectedCity, setSelectedCity] = useState();

  const [selectedRMS, setSelectedRMS] = useState();

  const [defaultCityValue, setDefaultCityValue] = useState();

  const { control, register, handleSubmit, setValue, getValues, errors, watch } =
    useForm({
      resolver: yupResolver(schema),
      defaultValues: {
        apply_hk_rules: false,
      },
    });
  const isHkRules = !!watch("apply_hk_rules");
  const depositLabel = isHkRules
    ? "Deposit (No. of Months)*"
    : "Deposit (No. of Weeks)*";
  const securityDepositLabel = isHkRules
    ? "Security Deposit (No. of Months) (if applicable)"
    : "Security Deposit (No. of Weeks) (if applicable)";

  useEffect(() => {
    if (propertyResponse.data) {
      setValue("apply_hk_rules", !!propertyResponse.data.apply_hk_rules);
    }
  }, [propertyResponse.data, setValue]);

  useEffect(() => {
    if (propertyResponse.data && cityOptions.length > 0) {
      setSnapshotCurrent(propertyResponse.data);
      setCurrentData(propertyResponse.data.id);

      if (propertyResponse.data.rmsId) {
        if (
          propertyResponse.data.clientId &&
          propertyResponse.data.clientPassword
        ) {
          handlePropertyDetails(
            {
              clientId: propertyResponse.data.clientId,
              clientPassword: propertyResponse.data.clientPassword,
            },
            authState.jwt,
            (response) => {
              console.log(response.data);
              setRmsTable([...response.data]);
              let rmsTable = response.data;
              let initialRMS;

              for (var i = 0; i < rmsTable.length; i++) {
                if (rmsTable[i].id == propertyResponse.data.rmsId) {
                  initialRMS = rmsTable[i];
                  break;
                }
              }
              if (initialRMS) {
                console.log(initialRMS);
                setSelectedRMS(initialRMS);
              }
            },
            (err) => {
              Swal.fire({
                icon: "error",
                titleText: "Error",
                text: "An Error has occured. Please try again.",
                allowOutsideClick: true,
                allowEscapeKey: true,
              });
            }
          );
        }

        const suiteArray = propertyResponse.data.suiteIds?.ids;
        if (suiteArray && Array.isArray(suiteArray)) {
          setSuiteIdsText(suiteArray.join(", "));
        }
      } else if (propertyResponse.error) {
        Toast.fire({
          icon: "error",
          text: "An Error has occured trying to retrieve Property. Please try again.",
        });
        history.replace("/dashboard/property");
      }
    }
  }, [propertyResponse, cityOptions]);

  /* useEffect(() => {
    if (rmsPropertyResponse.data) {
      setRmsTable([...rmsPropertyResponse.data]);
    }
  }, [rmsPropertyResponse]); */

  useEffect(() => {
    if (cityResponse.data && propertyResponse.data) {
      let data = cityResponse.data;
      let cityOptions = [];
      for (var i = 0; i < data.length; i++) {
        let city = data[i];
        cityOptions.push({
          label: city.name,
          value: city.id,
        });
      }
      setCityOptions(cityOptions);
      if (propertyResponse.data.city) {
        let defaultValue = cityOptions.find(
          (x) =>
            x.value == propertyResponse.data.city.id &&
            x.label == propertyResponse.data.city.name
        );
        if (defaultValue) {
          setDefaultCityValue(defaultValue);
          setValue("city", defaultValue);
        }
      }
    }
  }, [cityResponse, propertyResponse]);


  let [rmsCloudError, setRmsCloudError] = useState();
  let [suiteIdsError, setSuiteIdsError] = useState();

  const goBack = () => {
    window.location.href = "/dashboard/property";
  };

  /* const requirementChange = (value) => {
    if (value != null) {
      setValue("requirement", { label: value.label, value: value.value });
    }
  }; */

  const onSubmit = (values) => {
    let complete = true;
    const arraySuites = suiteIdsText
      .split(",")
      .map((s) => parseInt(s.trim(), 10))
      .filter((n) => !isNaN(n));
    if (arraySuites.length === 0) {
      complete = false;
      setSuiteIdsError("Please enter at least one valid Suite ID");
    } else {
      setSuiteIdsError(null);
    }
    if (!selectedRMS) {
      complete = false;
      setRmsCloudError("Please select a Property");
    }
    if (complete) {
      let dataObj = {};
      dataObj.suiteIds = { ids: arraySuites };

      dataObj.rmsId = selectedRMS.id;
      dataObj.name = values.name;
      dataObj.property_code = values.property_code;
      dataObj.stripeSecretKey = values.stripeSecretKey;
      dataObj.stripePublishableKey = values.stripePublishableKey;
      dataObj.stripeSignature = values.stripeSignature;
      dataObj.flywirePublicReference = values.flywirePublicReference;
      dataObj.flywireRecipientId = values.flywireRecipientId;
      dataObj.flywireSecret = values.flywireSecret;
      dataObj.flywireWechatPublicReference =
        values.flywireWechatPublicReference;
      dataObj.flywireWechatRecipientId = values.flywireWechatRecipientId;
      dataObj.flywireWechatSecret = values.flywireWechatSecret;
      dataObj.clientId = values.clientId;
      dataObj.clientPassword = values.clientPassword;
      dataObj.city = selectedCity;
      dataObj.bank_details = values.bank_details;

      dataObj.deposit_week = parseInt(values.deposit_week);

      if (
        values.security_deposit_week != null ||
        values.security_deposit_week != undefined
      ) {
        dataObj.security_deposit_week = parseInt(values.security_deposit_week);
      }

      dataObj.apply_hk_rules = !!values.apply_hk_rules;

      Swal.fire({
        title: "Create Updates",
        html: `<h4>Please provide a description before submitting your changes</h4>
        <textarea maxlength="100" type="text" id="actionDescription" class="swal2-input" placeholder="Description" font-size=18px style="height:auto!important" rows=5>`,
        confirmButtonText: "Confirm",
        focusConfirm: false,
        preConfirm: () => {
          const actionDescription =
            Swal.getPopup().querySelector("#actionDescription").value;
          if (!actionDescription) {
            Swal.showValidationMessage(`Please enter description`);
          }
          return {
            actionDescription: actionDescription,
            newData: dataObj,
            snapshotCurrent: snapshotCurrent,
            currentData: currentData,
            type: "props",
            action: "update",
          };
        },
      }).then((result) => {
        if (result.isConfirmed) {
          setAuditData(result.value);
        }
      });
    }
  };

  useEffect(() => {
    try {
      if (auditResponse.data) {
        Toast.fire({
          icon: "success",
          title: "Property Updation Audit Created",
        });
        history.push("/dashboard/property");
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message,
      });
    }
  }, [auditResponse]);

  const handleRMSSelected = ({ allSelected, selectedCount, selectedRows }) => {
    setSelectedRMS(selectedRows[0]);
  };

  const cityChange = (value) => {
    if (value != null) {
      setValue("city", { label: value.label, value: value.value });

      setSelectedCity(value.value);
    }
  };

  const loadPropertyID = () => {
    if (
      getValues("clientId").length <= 0 ||
      getValues("clientPassword").length <= 0
    ) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please enter Client ID and Client Password from RMS Cloud.",
      });
    } else {
      Swal.fire({
        title: "Retrieving Property Details",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCloseButton: false,
        showConfirmButton: false,
        willOpen: async () => {
          Swal.showLoading();
          const successResponse = (response) => {
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              },
            });
            Toast.fire({
              icon: "success",
              title: "Retrieved Property ID",
            });
            setRmsTable([...response.data]);
          };
          const failResponse = (err) => {
            Swal.fire({
              icon: "error",
              titleText: "Error",
              text: "An Error has occured. Please try again.",
              allowOutsideClick: true,
              allowEscapeKey: true,
            });
            //updateTableData();
          };
          await handlePropertyDetails(
            {
              clientId: getValues("clientId"),
              clientPassword: getValues("clientPassword"),
            },
            authState ? authState.jwt : "",
            successResponse,
            failResponse
          );
        },
      });
    }
  };

  const renderContent = () => {
    return (
      <Box
        component="form"
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        sx={{ width: "100%" }}
      >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormPageCard>
                <FormPageHeader
                  title={authState.editAccess ? "Edit Property" : "Property"}
                  onBack={goBack}
                  subtitle={
                    authState.editAccess
                      ? "Please fill in the required fields."
                      : undefined
                  }
                />
                <TextField
                  name="name"
                  margin="normal"
                  fullWidth
                  label="Property Name*"
                  variant="outlined"
                  inputRef={register}
                  defaultValue={
                    propertyResponse.data ? propertyResponse.data.name : null
                  }
                  error={errors.name != null}
                  helperText={errors.name != null ? errors.name.message : null}
                  disabled={auditResponse.loading || !authState.editAccess}
                />
                <TextField
                  name="property_code"
                  margin="normal"
                  fullWidth
                  label="Property Code (used to identify Property's Tariffs on RMS Cloud)*"
                  variant="outlined"
                  inputRef={register}
                  defaultValue={
                    propertyResponse.data
                      ? propertyResponse.data.property_code
                      : null
                  }
                  error={errors.property_code != null}
                  helperText={
                    errors.property_code != null
                      ? errors.property_code.message
                      : null
                  }
                  disabled={auditResponse.loading || !authState.editAccess}
                />
                <TextField
                  name="clientId"
                  margin="normal"
                  fullWidth
                  label="RMS Client ID*"
                  variant="outlined"
                  inputRef={register}
                  defaultValue={
                    propertyResponse.data
                      ? propertyResponse.data.clientId
                      : null
                  }
                  error={errors.clientId != null}
                  helperText={
                    errors.clientId != null ? errors.clientId.message : null
                  }
                  disabled={auditResponse.loading || !authState.editAccess}
                />
                <TextField
                  name="clientPassword"
                  margin="normal"
                  fullWidth
                  label="RMS Client Password*"
                  variant="outlined"
                  inputRef={register}
                  defaultValue={
                    propertyResponse.data
                      ? propertyResponse.data.clientPassword
                      : null
                  }
                  error={errors.clientPassword != null}
                  helperText={
                    errors.clientPassword != null
                      ? errors.clientPassword.message
                      : null
                  }
                  disabled={auditResponse.loading || !authState.editAccess}
                />
                {authState.editAccess && (
                  <Button
                    onClick={loadPropertyID}
                    type="button"
                    size="large"
                    variant="contained"
                    color="primary"
                    sx={{ mt: 1.25, mb: 1.25 }}
                    disabled={auditResponse.loading || !authState.editAccess}
                  >
                    Load Property ID
                  </Button>
                )}

                <TextField
                  name="stripeSecretKey"
                  margin="normal"
                  fullWidth
                  label="Stripe Secret Key*"
                  variant="outlined"
                  inputRef={register}
                  defaultValue={
                    propertyResponse.data
                      ? propertyResponse.data.stripeSecretKey
                      : null
                  }
                  error={errors.stripeSecretKey != null}
                  helperText={
                    errors.stripeSecretKey != null
                      ? errors.stripeSecretKey.message
                      : null
                  }
                  disabled={auditResponse.loading || !authState.editAccess}
                />
                <TextField
                  name="stripePublishableKey"
                  margin="normal"
                  fullWidth
                  label="Stripe Publishable Key*"
                  variant="outlined"
                  inputRef={register}
                  defaultValue={
                    propertyResponse.data
                      ? propertyResponse.data.stripePublishableKey
                      : null
                  }
                  error={errors.stripePublishableKey != null}
                  helperText={
                    errors.stripePublishableKey != null
                      ? errors.stripePublishableKey.message
                      : null
                  }
                  disabled={auditResponse.loading || !authState.editAccess}
                />
                <TextField
                  name="stripeSignature"
                  margin="normal"
                  fullWidth
                  label="Stripe Signature*"
                  variant="outlined"
                  inputRef={register}
                  defaultValue={
                    propertyResponse.data
                      ? propertyResponse.data.stripeSignature
                      : null
                  }
                  error={errors.stripeSignature != null}
                  helperText={
                    errors.stripeSignature != null
                      ? errors.stripeSignature.message
                      : null
                  }
                  disabled={auditResponse.loading || !authState.editAccess}
                />
                <TextField
                  name="flywirePublicReference"
                  margin="normal"
                  fullWidth
                  label="Flywire Public Reference"
                  variant="outlined"
                  inputRef={register}
                  defaultValue={
                    propertyResponse.data
                      ? propertyResponse.data.flywirePublicReference
                      : null
                  }
                  error={errors.flywirePublicReference != null}
                  helperText={
                    errors.flywirePublicReference != null
                      ? errors.flywirePublicReference.message
                      : null
                  }
                  disabled={auditResponse.loading || !authState.editAccess}
                />
                <TextField
                  name="flywireRecipientId"
                  margin="normal"
                  fullWidth
                  label="Flywire Recipient Id"
                  variant="outlined"
                  inputRef={register}
                  defaultValue={
                    propertyResponse.data
                      ? propertyResponse.data.flywireRecipientId
                      : null
                  }
                  error={errors.flywireRecipientId != null}
                  helperText={
                    errors.flywireRecipientId != null
                      ? errors.flywireRecipientId.message
                      : null
                  }
                  disabled={auditResponse.loading || !authState.editAccess}
                />
                <TextField
                  name="flywireSecret"
                  margin="normal"
                  fullWidth
                  label="Flywire Public Reference"
                  variant="outlined"
                  inputRef={register}
                  defaultValue={
                    propertyResponse.data
                      ? propertyResponse.data.flywireSecret
                      : null
                  }
                  error={errors.flywireSecret != null}
                  helperText={
                    errors.flywireSecret != null
                      ? errors.flywireSecret.message
                      : null
                  }
                  disabled={auditResponse.loading || !authState.editAccess}
                />
                <TextField
                  name="flywireWechatPublicReference"
                  margin="normal"
                  fullWidth
                  label="Flywire WeChat Public Reference"
                  variant="outlined"
                  inputRef={register}
                  defaultValue={
                    propertyResponse.data
                      ? propertyResponse.data.flywireWechatPublicReference
                      : null
                  }
                  error={errors.flywireWechatPublicReference != null}
                  helperText={
                    errors.flywireWechatPublicReference != null
                      ? errors.flywireWechatPublicReference.message
                      : null
                  }
                  disabled={auditResponse.loading || !authState.editAccess}
                />
                <TextField
                  name="flywireWechatRecipientId"
                  margin="normal"
                  fullWidth
                  label="Flywire WeChat Recipient ID"
                  variant="outlined"
                  inputRef={register}
                  defaultValue={
                    propertyResponse.data
                      ? propertyResponse.data.flywireWechatRecipientId
                      : null
                  }
                  error={errors.flywireWechatRecipientId != null}
                  helperText={
                    errors.flywireWechatRecipientId != null
                      ? errors.flywireWechatRecipientId.message
                      : null
                  }
                  disabled={auditResponse.loading || !authState.editAccess}
                />
                <TextField
                  name="flywireWechatSecret"
                  margin="normal"
                  fullWidth
                  label="Flywire WeChat Secret"
                  variant="outlined"
                  inputRef={register}
                  defaultValue={
                    propertyResponse.data
                      ? propertyResponse.data.flywireWechatSecret
                      : null
                  }
                  error={errors.flywireWechatSecret != null}
                  helperText={
                    errors.flywireWechatSecret != null
                      ? errors.flywireWechatSecret.message
                      : null
                  }
                  disabled={auditResponse.loading || !authState.editAccess}
                />
                <TextField
                  name="bank_details"
                  margin="normal"
                  fullWidth
                  multiline={true}
                  label="Bank Details"
                  variant="outlined"
                  defaultValue={
                    propertyResponse.data
                      ? propertyResponse.data.bank_details
                      : null
                  }
                  inputRef={register}
                  error={errors.bank_details != null}
                  helperText={
                    errors.bank_details != null
                      ? errors.bank_details.message
                      : null
                  }
                  disabled={auditResponse.loading || !authState.editAccess}
                />
                <TextField
                  name="deposit_week"
                  margin="normal"
                  fullWidth
                  label={depositLabel}
                  variant="outlined"
                  inputRef={register}
                  type="number"
                  defaultValue={
                    propertyResponse.data
                      ? propertyResponse.data.deposit_week
                      : null
                  }
                  error={errors.deposit_week != null}
                  helperText={
                    errors.deposit_week != null
                      ? errors.deposit_week.message
                      : null
                  }
                  disabled={auditResponse.loading || !authState.editAccess}
                />
                <TextField
                  name="security_deposit_week"
                  margin="normal"
                  fullWidth
                  label={securityDepositLabel}
                  variant="outlined"
                  inputRef={register}
                  type="number"
                  defaultValue={
                    propertyResponse.data
                      ? propertyResponse.data.security_deposit_week
                      : null
                  }
                  error={errors.security_deposit_week != null}
                  helperText={
                    errors.security_deposit_week != null
                      ? errors.security_deposit_week.message
                      : null
                  }
                  disabled={auditResponse.loading || !authState.editAccess}
                />
                <Controller
                  name="apply_hk_rules"
                  control={control}
                  defaultValue={false}
                  render={({ onChange, value }) => (
                    <FormControlLabel
                      sx={{ mt: 1 }}
                      control={
                        <Switch
                          color="primary"
                          checked={!!value}
                          onChange={(e) => onChange(e.target.checked)}
                          disabled={
                            auditResponse.loading || !authState.editAccess
                          }
                        />
                      }
                      label="Apply HK rules"
                    />
                  )}
                />
                <Typography component="p" sx={imageLabelSx}>City</Typography>
                {cityOptions.length > 0 && propertyResponse.data && (
                  <div>
                    <Controller
                      name="city"
                      control={control}
                      defaultValue={defaultCityValue ? defaultCityValue : null}
                      render={({ ...props }) => {
                        return (
                          <Select
                            styles={{
                              control: (provided, state) => ({
                                ...provided,
                                borderColor: errors.type
                                  ? "red"
                                  : provided.borderColor,
                              }),
                            }}
                            defaultValue={
                              defaultCityValue ? defaultCityValue : null
                            }
                            options={cityOptions}
                            onChange={cityChange}
                            isDisabled={
                              auditResponse.loading || !authState.editAccess
                            }
                          />
                        );
                      }}
                    />
                    {errors.city && (
                      <Box sx={errorTextSx}>{errors.city.message}</Box>
                    )}
                  </div>
                )}
              </FormPageCard>
            </Grid>
            <Grid item xs={12} lg={6}>
              <FormPageCard sx={{ height: 560 }}>
                <Typography component="h1" variant="h5">
                  RMS Cloud Properties
                </Typography>
                <p>
                  {authState.editAccess &&
                    `Enter RMS Client ID and Client Password, then select "Load
                  Property ID" to load the property details.`}
                </p>
                <RMSProperties
                  onSelectedRowsChange={handleRMSSelected}
                  data={rmsTable}
                  selectedRow={selectedRMS}
                  disabled={auditResponse.loading || !authState.editAccess}
                />
                {rmsCloudError && (
                  <Box sx={errorTextSx}>{rmsCloudError}</Box>
                )}
              </FormPageCard>
            </Grid>
            <Grid item xs={12} lg={6}>
              <FormPageCard>
                <Typography component="h1" variant="h5">
                  Suite IDs
                </Typography>
                <p>
                  {authState.editAccess
                    ? `Enter the Suite ID(s) for this property, separated by commas (e.g. 13030, 16435).`
                    : `Suite ID(s) for this property.`}
                </p>
                <TextField
                  fullWidth
                  label="Suite IDs (comma-separated)"
                  variant="outlined"
                  value={suiteIdsText}
                  onChange={(e) => setSuiteIdsText(e.target.value)}
                  disabled={auditResponse.loading || !authState.editAccess}
                  placeholder="e.g. 13030, 16435"
                  error={!!suiteIdsError}
                  helperText={suiteIdsError || null}
                />
              </FormPageCard>
            </Grid>
            {authState.editAccess && (
              <Grid item xs={12}>
                <FormPageCard>
                  <FormActions>
                  <Button
                      type="submit"
                      size="large"
                      variant="contained"
                      color="primary"
                      disabled={auditResponse.loading}
                    >
                      Submit
                    </Button>
                </FormActions>
                </FormPageCard>
              </Grid>
            )}
          </Grid>
        </Box>
    );
  };

  return (
    <FormPageShell>
      {propertyResponse.loading && (
        <FormPageCard>
          <Loader />
        </FormPageCard>
      )}
      {!propertyResponse.loading && renderContent()}
    </FormPageShell>
  );
};

export default EditProperty;
